<template>
  <div>

    <el-form :model="searchForm" inline size="small">
      <el-form-item :label="$t('编号')">
        <el-input :placeholder="$t('编号')" v-model="searchForm.num" clearable />
      </el-form-item>

      <el-form-item :label="$t('话题')">
        <el-input :placeholder="$t('请输入话题')" v-model="searchForm.topicName" clearable />
      </el-form-item>

      <el-form-item :label="$t('发布时间')">
        <date-time-range-picker
            :end-time.sync="searchForm.endCreateTime"
            :start-time.sync="searchForm.startCreateTime" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{ $t('搜索') }}</el-button>
        <el-button @click="$refs.list.reset()">{{ $t('重置') }}</el-button>
      </el-form-item>

    </el-form>

    <table-list
        ref="list"
        @query="handleLoadList"
        :search-params="searchForm"
        :request-params="{userNum: $route.query.num}"
        :data="tableData"
        v-bind="$attrs"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column align="center" prop="num" :label="$t('编号')" />
      <el-table-column align="center" prop="content" :label="$t('内容')" />
      <el-table-column align="center" prop="name" :label="$t('图片')">
        <template v-slot="{row}">
          <div class="fb-link-flex">
            <el-image
                v-for="item in row.photoList"
                :key="item"
                fit="cover"
                :preview-src-list="item.photoList"
                :src="$api.file.downloadImg + item" />
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="topic" :label="$t('话题')" />
      <el-table-column align="center" :label="$t('评论数')">
        <template v-slot="{row}">
          <el-link type="primary" :underline="false" @click="$router.push('/comment/list?code=' + row.code)" >{{row.commentCount}}</el-link>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="likeCount" :label="$t('点赞数')" />
      <el-table-column align="center" :label="$t('发布时间')">
        <template v-slot="{row}">{{row.createTime | formatDate}}</template>
      </el-table-column>
      <el-table-column :label="$t('操作')" align="center">
        <template v-slot="{row}">
          <el-link type="primary" :underline="false" @click="$router.push('/dynamic/detail?code=' + row.code)" >{{ $t('查看') }}</el-link>
        </template>
      </el-table-column>
    </table-list>
  </div>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker";
export default {
  name: "UserDynamic",
  components: {DateTimeRangePicker, TableList},
  props: {
    tabCurrent: {
      type: String,
      default: ""
    },
    current: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      searchForm: {},
      tableData: []
    }
  },
  methods:  {
    async handleLoadList(params, setTotal) {
      try {
        let res = await request(this.$api.dynamics.list, params);
        for (const key in res) {
          if(Array.isArray(res[key])) {
            this.tableData = res[key];
          }
        }
        this.tableData = this.tableData.map(item => {
          item.photoList = item.photo ? item.photo.split(",") : [];
          return item
        })
        setTotal(res.pager.itemCount);
      }catch(e) {
        console.log(e);
      }
    }
  },
  watch: {
    current: {
      handler(val) {
        if(val === this.tabCurrent) {
          this.$nextTick(() => {
            this.$refs.list.handleRequest();
          })
        }
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>
.el-image {
  width: 70px;
  height: 70px;
  border-radius: 10px;
}
</style>
